import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "@clerk/react";
import axios from "axios";
import { useApi, API, errMsg } from "@/lib/api";
import { t } from "@/i18n";
import { GuestPicker } from "@/components/GuestPicker";

function JoinForm({ info, slug }) {
  const api = useApi();
  const [role, setRole] = useState(info.roles[0]);
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const { data } = await api.post(`/join/${slug}`, { role, display_name: name });
      sessionStorage.setItem("smboi-org", data.org_id);
      window.location.assign("/chat?welcome=1");
    } catch (e2) { setErr(errMsg(e2)); setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="card stack-sm w-full max-w-md" data-testid="join-form">
      <span className="mono-label">{t("Job title")}</span>
      {info.roles.map((r) => <label key={r} className="flex items-center gap-2 cursor-pointer"><input type="radio" checked={role === r} onChange={() => setRole(r)} data-testid={`join-role-${r.replace(/\s+/g, "-").toLowerCase()}`} /> {t(r)}</label>)}
      <span className="mono-label mt-2">{t("Display name")}</span>
      <input className="field" value={name} onChange={(e) => setName(e.target.value)} maxLength={30} required placeholder={t("e.g. Pearl")} data-testid="join-name-input" />
      {err && <p className="text-sm text-[var(--status-error)]" data-testid="join-error">{err}</p>}
      <button className="btn btn-primary" disabled={busy || !name.trim()} data-testid="join-submit">{t(busy ? "Joining…" : "Join the Krusty Krab")}</button>
    </form>
  );
}

export default function JoinPage() {
  const { slug } = useParams();
  const { isSignedIn, isLoaded } = useAuth();
  const [info, setInfo] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { axios.get(`${API}/public/join/${slug}`).then((r) => setInfo(r.data)).catch(() => setMissing(true)); }, [slug]);
  const back = encodeURIComponent(`/join/${slug}`);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5 p-6 text-center" data-org="krusty-krab-restaurant" data-testid="join-page">
      <img src="/mascot.png" alt="" className="h-16 w-auto" />
      <h1 className="text-4xl font-bold tracking-tight">{info ? t("Join {org}", { org: info.name }) : t("Join")}</h1>
      <p className="muted max-w-md" data-testid="join-explainer">{t("This is a demo restaurant with fictional data. Join as a new hire and ask anything.")}</p>
      {missing && <p data-testid="join-missing">{t("This team isn't open to join.")}</p>}
      {info && !info.open && <p className="font-semibold text-[var(--status-error)]" data-testid="join-closed">{t("Sign-ups are closed")}</p>}
      {info && info.open && isLoaded && (isSignedIn ? (
        <>
          <GuestPicker slug={slug} />
          <p className="text-xs faint uppercase tracking-widest">{t("Or join with your account")}</p>
          <JoinForm info={info} slug={slug} />
        </>
      ) : (
        <>
          <GuestPicker slug={slug} />
          <p className="text-xs faint uppercase tracking-widest">{t("Or keep a lasting account")}</p>
          <div className="flex flex-wrap gap-2 justify-center" data-testid="join-auth">
            <Link className="btn btn-primary" to={`/sign-up?redirect_url=${back}`} data-testid="join-sign-up">{t("Sign up to join")}</Link>
            <Link className="btn btn-ghost" to={`/sign-in?redirect_url=${back}`} data-testid="join-sign-in">{t("I already have an account")}</Link>
          </div>
        </>
      ))}
    </div>
  );
}
